
import { GalleryComponent } from "../../../componets";

export default function GalleryPage() {
    return <GalleryComponent />;
}